import { VhcTab } from './types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useVhcRecordPage = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<VhcTab>('vhc');

  const handleTabSelect = (tabKey: string | null) => {
    if (tabKey) setActiveTab(tabKey as VhcTab);
  };

  const handleClose = () => {
    navigate('/vhc/record');
  };

  return {
    activeTab,
    handleTabSelect,
    handleClose
  };
};
